/**
 * @file sendJsErrorLog.js
 * @author sunhemeng@baidu.com
*/
/* globals getApp  getCurrentPages */
import { sendWebb } from './log';
export function sendJsErrorLog(Vue) {
  if (!Vue || !Vue.config) {
    return;
  }
  // 可捕获项目中大部分错误
  Vue.config.errorHandler = function (error, vm, info) {
    if (!error) {
      return;
    }
    sendSpyLog({
      info,
      type: 'errorHandler',
      stack: error.stack,
      message: error.toString()
    });
  };
  // 捕获未catch的promise错误
  window.addEventListener('unhandledrejection', event => {
    // reason 可能是个字符串或者对象
    let message = event && (JSON.stringify(event, Object.getOwnPropertyNames(event)), 2);
    sendSpyLog({
      type: 'unhandledrejection',
      stack: message
    });
  });
  // 可监听到非promise的异步错误
  window.addEventListener('error', function (event = {}) {
    const {
      error = {}
    } = event;
    sendSpyLog({
      type: 'error',
      stack: error.stack,
      message: error.message
    });
  });
}
/**
 * @param {String} type 错误类型
 * @param {String} message 错误信息
 * @param {Object} stack 错误堆栈
 * @param {String} info errorHandler 会传此函数
*/
export function sendSpyLog({
  type = '',
  message,
  stack,
  info = '未知'
}) {
  let paths = getCurrentPages().map((item = {}) => {
    return item.uri + (item.options && item.options.qid || '');
  });
  sendWebb({
    type: 'except',
    group: 'lawMobile',
    info: {
      type,
      stack: stack,
      paths: paths.join('->'),
      msg: `Error: ${message}, info: ${info}`
    },
    dim: {
      // spy 搜索条件
      type
    }
  });
}